
(function () {
  var re = /^You can't add more .* to the cart\.$/;

  var timer = setInterval(function () {
    var utils = window.tlFreeGiftOffer && window.tlFreeGiftOffer.utils;
    if (!utils || utils.__patchedSilentLimit) return;

    var original = utils.createAjaxCartErrorResponse;
    if (typeof original !== "function") return;

    utils.createAjaxCartErrorResponse = async function (statusCode, errMessage) {
      if (typeof errMessage === "string" && re.test(errMessage)) {
        var cartRes = await fetch((window.Shopify?.routes?.root || "/") + "cart.js", {
          headers: { Accept: "application/json" }
        });
        var cartData = await cartRes.text();

        return new Response(cartData, {
          status: 200,
          headers: { "Content-Type": "application/json" }
        });
      }

      return original.apply(this, arguments);
    };

    utils.__patchedSilentLimit = true;
    clearInterval(timer);
  }, 300);
})();
